import { Box } from "@mui/material"
import type { FC } from "react"
import { useState } from "react"

import { PAY_FILE_COMMENT_MAX_LENGTH } from "../constants"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"
import { AerosTextField } from "@/components/UiKit/AerosTextField/AerosTextField"

interface PayFileRemoveApprovalConfirmationDialogProps {
  isSubmitting: boolean
  onClose: () => void
  onConfirm: (comment: string) => void
}

export const PayFileRemoveApprovalConfirmationDialog: FC<PayFileRemoveApprovalConfirmationDialogProps> = ({
  isSubmitting,
  onClose,
  onConfirm,
}) => {
  const [comment, setComment] = useState("")

  const handleConfirm = () => {
    onConfirm(comment.trim())
  }

  const content = (
    <Box className='flex flex-col gap-6 text-left'>
      <span className='text-center'>This action will change the pay file status back to Pending.</span>
      <AerosTextField
        label='Remove Approval Comment'
        required
        value={comment}
        onChange={setComment}
        placeholder='Enter comment...'
        multiline
        minRows={3}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { maxLength: PAY_FILE_COMMENT_MAX_LENGTH } }}
        data-testid='pay-file.remove-approval-confirmation-dialog.comment-field'
      />
    </Box>
  )

  return (
    <ConfirmationDialog
      title='Are you sure you want to remove approval for this pay file?'
      content={content}
      closeLabel='Go Back'
      confirmLabel='Remove Approval'
      isWarning
      confirmDisabled={!comment.trim() || isSubmitting}
      testIdPrefix='pay-file.remove-approval-confirmation-dialog'
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  )
}
